module.exports = __webpack_public_path__ + "img/pdf-standard.6eec3136.png";